var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinuxBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 37,
    viewBox: "0 0 123 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.455556,
    y: 0.733388,
    width: 122.089,
    height: 35.5333,
    rx: 4.1,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.455556,
    y: 0.733388,
    width: 122.089,
    height: 35.5333,
    rx: 4.1,
    stroke: "#A6A6A6",
    strokeWidth: 0.911111
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0732 8.00098V7.21143H39.4881V7.99363H38.6757C38.6757 7.99363 38.352 7.99814 38.352 8.3172V16.6558H41.0784C41.0784 16.6558 41.5386 16.9164 41.6611 14.5246H42.7955V17.453H35.0833V16.748H35.9266C35.9266 16.748 36.2869 16.6404 36.2869 16.3875V8.28411C36.2869 8.28411 36.2485 8.02346 35.8499 8.02346L35.0732 8.00098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4401 11.2889V10.6757L45.5407 9.87842H46.3534V16.487C46.3534 16.487 46.3687 16.8395 46.8286 16.8395H47.3959V17.4681H43.4248V16.8088H44.0226C44.0226 16.8088 44.4213 16.7627 44.4521 16.5174V11.2889H43.4401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8574 17.4596H48.1008V16.8003H48.6835C48.6835 16.8003 49.0819 16.7545 49.0973 16.4785V11.2345H48.0547V10.5907L50.2013 9.85449H50.9679V10.7897C50.9679 10.7897 52.6393 9.88523 53.6207 9.88523C53.6207 9.88523 55.5832 9.73181 55.5986 11.8785V16.417C55.5986 16.417 55.6447 16.7849 56.0892 16.7849H56.6872V17.4596H52.946V16.7544H53.4673C53.4673 16.7544 53.7433 16.7391 53.8045 16.4631V12.5071C53.8045 12.5071 53.7126 11.1424 52.3786 11.1885C52.3786 11.1885 51.4586 11.311 50.9832 11.4798V16.4784C50.9832 16.4784 51.0446 16.7391 51.3668 16.7695H51.8727L51.8574 17.4596Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1748 11.226H57.1475V10.6125L59.2328 9.87672H60.076V14.8754C60.076 14.8754 60.0148 16.4545 61.5021 16.332C61.5021 16.332 62.6827 16.2093 62.836 16.0864V11.2414H61.8242V10.6279L63.8787 9.86133H64.7221V16.4392C64.7221 16.4392 64.7068 16.746 65.1054 16.7764H65.7033V17.4971H62.8361V16.6691C62.8361 16.6691 61.3795 17.6351 60.1989 17.6198C60.1989 17.6198 58.2361 17.7271 58.1749 15.4885V11.226H58.1748Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1947 10.6795V9.97412H69.8595V10.6642C69.8595 10.6642 69.0468 10.6334 69.2767 11.0321L70.4726 12.7646L71.6533 11.0321C71.6533 11.0321 71.9447 10.6795 71.0093 10.71V10.0049H73.8152V10.6795C73.8152 10.6795 73.1253 10.7102 72.8341 11.0167L71.0247 13.4393L73.2786 16.6746C73.2786 16.6746 73.5239 16.8279 74.0912 16.8433V17.4719H70.4881V16.9045C70.4881 16.9045 71.3007 16.9045 71.04 16.46L69.7672 14.5587L68.4333 16.4907C68.4333 16.4907 68.0961 16.8126 69.1079 16.7973V17.4411H66.1641V16.8126C66.1641 16.8126 66.854 16.8587 67.1454 16.4754L69.1387 13.8839L67.1761 11.0167C67.1761 11.0167 67.084 10.6949 66.1947 10.6795Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9545 9.59103H73.7939V9.19482H74.5932V9.59103H74.4393V9.35527H74.2755V9.91556H74.4326V10.0694H73.9608V9.91867H74.1115V9.35527H73.9513L73.9545 9.59103Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6768 10.0755V9.91859H74.7554V9.3583H74.6768V9.18799H74.9125V9.35508H75.001V9.52545H75.0762V9.59406H75.1583V9.51563H75.2433V9.36501H75.3188V9.19137H75.5578V9.35508H75.479V9.9217H75.5578V10.0788H75.1614V9.91859H75.322V9.67613H75.2402V9.75139H75.1614V9.83985H75.0762V9.75799H75.001V9.6727H74.9125V9.90878H75.0762V10.0772L74.6768 10.0755Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4377 23.7944C34.4377 23.7944 34.4147 22.3685 36.6728 21.8454C36.6728 21.8454 44.4003 19.5685 71.3775 18.8784C71.3775 18.8784 76.2071 19.0856 72.4123 20.3965C72.4123 20.3965 59.5101 22.3972 56.6813 22.6733C56.6813 22.6733 42.1233 24.5361 37.2937 27.5719C37.2937 27.5719 36.6373 28.0697 36.2255 28.499C36.2255 28.499 35.8292 28.7623 35.5002 28.3483C35.5002 28.3483 34.419 27.2849 34.4377 23.7944Z",
    fill: "url(#paint0_linear_8234_14407)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5534 19.4806C86.5534 21.0715 84.8158 22.3613 82.6723 22.3613C80.5285 22.3613 78.791 21.0715 78.791 19.4806C78.791 17.8897 80.5285 16.6001 82.6723 16.6001C84.8158 16.6 86.5534 17.8897 86.5534 19.4806Z",
    fill: "url(#paint1_linear_8234_14407)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7602 28.9206C85.7602 28.9206 83.808 28.7813 83.4365 28.6882C83.4365 28.6882 82.9718 28.6882 82.5535 28.7813C82.5535 28.7813 80.834 29.0601 79.9508 28.9206L75.2571 22.6468C75.2571 22.6468 74.5138 21.1598 76.4655 17.6741C76.4655 17.6741 78.3711 14.7463 78.6498 14.4677C78.9286 14.1888 79.5793 12.7947 79.5328 11.1214C79.5328 11.1214 78.2315 5.17296 82.9718 4.98725C82.9718 4.98725 86.4572 4.33636 87.0614 8.28661C87.0614 8.28661 87.1077 11.4933 87.2474 12.0975C87.2474 12.0975 86.8291 12.6551 89.0597 15.3042C89.0597 15.3042 93.3351 20.0909 90.8257 23.2974L85.7602 28.9206Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3088 12.9664C80.3088 12.9664 80.1478 15.0822 78.8598 17.6122C78.8598 17.6122 77.8478 19.5443 77.6868 21.614C77.6868 21.614 76.261 20.0041 78.2619 16.8072C78.2619 16.8072 78.4038 16.6231 78.3058 16.5806C78.3058 16.5806 78.2396 16.5118 78.1125 16.7343C78.1125 16.7343 76.0234 19.7971 77.0966 21.6678C77.0966 21.6678 77.3419 22.0817 77.8632 22.5262C77.8632 22.5262 79.0899 23.3389 79.4425 23.7072C79.7953 24.075 80.884 25.1484 80.2398 25.7462C80.2398 25.7462 79.9945 26.0068 79.5805 25.961C79.5805 25.961 80.209 27.8777 83.1529 27.7702C83.1529 27.7702 84.947 27.5709 86.189 26.4977L90.9575 22.8485L90.8349 22.5878C90.8349 22.5878 91.4636 21.6064 89.3322 20.7786C89.3322 20.7786 90.0987 18.6931 87.6761 16.194C87.6761 16.194 87.3849 15.9945 87.5076 16.2859C87.5076 16.2859 89.7157 18.2485 88.7955 20.6099L88.3203 20.5792C88.3203 20.5792 87.9062 18.6778 86.9248 16.9145C86.9248 16.9145 85.3686 13.6334 85.3225 12.3453C85.2768 11.0573 80.3088 12.9664 80.3088 12.9664Z",
    fill: "url(#paint2_linear_8234_14407)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.9883 14.3363C84.9883 15.1148 84.004 15.7462 82.79 15.7462C81.5761 15.7462 80.5918 15.1148 80.5918 14.3363C80.5918 13.5574 81.5761 12.9263 82.79 12.9263C84.004 12.9263 84.9883 13.5574 84.9883 14.3363Z",
    fill: "url(#paint3_linear_8234_14407)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9385 12.2206C79.9385 12.2206 81.5975 14.347 83.8898 12.7333C83.8898 12.7333 84.1764 12.3863 85.051 12.1602",
    stroke: "#F7A81C",
    strokeWidth: 0.617187,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.8645 7.05423C85.967 8.21666 84.7684 9.27217 83.187 9.41175C81.6059 9.55138 80.2408 8.72245 80.138 7.56018C80.0354 6.39776 81.234 5.34252 82.8154 5.20288C84.3967 5.06304 85.762 5.89219 85.8645 7.05423Z",
    fill: "url(#paint4_linear_8234_14407)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8632 9.89398C81.8632 10.6751 81.456 11.3085 80.9536 11.3085C80.4514 11.3085 80.0439 10.6751 80.0439 9.89398C80.0439 9.11263 80.4514 8.47949 80.9536 8.47949C81.456 8.47949 81.8632 9.11263 81.8632 9.89398Z",
    fill: "#CAC7C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.324 9.93695C85.324 10.8445 84.7563 11.5804 84.0566 11.5804C83.3565 11.5804 82.7891 10.8445 82.7891 9.93695C82.7891 9.02949 83.3565 8.29395 84.0566 8.29395C84.7563 8.29395 85.324 9.02949 85.324 9.93695Z",
    fill: "#CAC7C6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2767 10.2329C81.2767 10.6318 81.1048 10.9552 80.8925 10.9552C80.6807 10.9552 80.5088 10.6317 80.5088 10.2329C80.5088 9.8342 80.6807 9.51074 80.8925 9.51074C81.1048 9.51074 81.2767 9.8342 81.2767 10.2329Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.1608 9.94907C81.1608 10.1324 81.0472 10.2807 80.907 10.2807C80.7667 10.2807 80.6533 10.1324 80.6533 9.94907C80.6533 9.76578 80.7667 9.61719 80.907 9.61719C81.0472 9.61713 81.1608 9.76572 81.1608 9.94907Z",
    fill: "url(#paint5_linear_8234_14407)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5966 10.2666C84.5966 10.8416 84.3169 11.3075 83.9718 11.3075C83.6264 11.3075 83.3467 10.8416 83.3467 10.2666C83.3467 9.69173 83.6264 9.22559 83.9718 9.22559C84.3169 9.22553 84.5966 9.69173 84.5966 10.2666Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.4062 9.85452C84.4062 10.119 84.2213 10.333 83.993 10.333C83.7649 10.333 83.5801 10.119 83.5801 9.85452C83.5801 9.59055 83.7649 9.37646 83.993 9.37646C84.2212 9.37641 84.4062 9.59055 84.4062 9.85452Z",
    fill: "url(#paint6_linear_8234_14407)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3963 12.9163C80.3963 12.9163 79.5294 12.4827 79.7264 11.8915C79.7264 11.8915 79.7394 11.5763 80.1601 11.274C80.5804 10.9717 80.528 11.0113 80.5804 10.9717C80.6329 10.9323 81.5658 10.2624 81.8548 10.1834C82.1438 10.1045 82.7744 10.0915 83.1819 10.341C83.5889 10.5908 84.5611 10.9717 84.732 11.0113C84.9028 11.0507 85.3757 11.3134 85.4413 11.5892C85.507 11.8653 85.3757 12.2593 85.1655 12.4957C84.9555 12.7323 84.5873 12.9817 84.1539 13.1658C83.7203 13.3497 83.5627 13.4811 83.2868 13.6387C83.011 13.7965 82.2489 14.1117 81.592 13.7833C80.9351 13.4548 81.0273 13.3234 80.817 13.2053C80.6067 13.0868 80.3963 12.9163 80.3963 12.9163Z",
    fill: "#F1883B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5364 12.8925C80.5364 12.8925 79.7062 12.4777 79.8952 11.9115C79.8952 11.9115 79.9076 11.6099 80.3099 11.3206C80.7122 11.0314 80.6622 11.0691 80.7122 11.0314C80.7626 10.9938 81.6555 10.3525 81.9321 10.277C82.2086 10.2014 82.8126 10.189 83.2023 10.428C83.5919 10.667 84.5227 11.0314 84.6858 11.0691C84.8495 11.1069 85.3022 11.3583 85.3649 11.6224C85.4278 11.8864 85.302 12.2639 85.101 12.4902C84.8999 12.7166 84.5476 12.9556 84.1327 13.1314C83.7177 13.3075 83.567 13.4331 83.3026 13.5841C83.0388 13.7352 82.3093 14.0368 81.6808 13.7224C81.052 13.4079 81.1401 13.2824 80.9388 13.1691C80.7374 13.056 80.5364 12.8925 80.5364 12.8925Z",
    fill: "#FBB91D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.834 11.2221C80.834 11.2221 81.4522 10.2721 82.3121 10.2568C82.3121 10.2568 83.7295 10.5585 83.9708 11.177C83.9708 11.177 83.6693 12.0214 82.3268 12.0214C82.3268 12.0214 81.0603 12.097 80.834 11.2221Z",
    fill: "url(#paint7_linear_8234_14407)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.1761 22.4808C76.1761 22.4808 75.0722 20.6102 76.6361 17.8808C76.6361 17.8808 77.2189 16.7155 78.3534 15.3663C78.3534 15.3663 78.9976 14.7223 78.5681 15.4582C78.5681 15.4582 77.2801 17.5436 77.0962 18.0035C76.9121 18.4636 75.9001 19.9048 77.2493 22.6953C78.5987 25.4862 76.1761 22.4808 76.1761 22.4808Z",
    fill: "url(#paint8_linear_8234_14407)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6293 27.7996C80.6497 27.1278 79.9786 26.3826 79.2668 25.5323C78.5551 24.6819 78.073 23.4407 78.073 23.4407C77.4112 21.9629 76.4458 21.9768 76.2073 22.0051C75.5391 22.0008 75.0021 22.6485 75.0021 22.6485C74.6567 23.1473 74.3484 23.4109 74.1484 23.5448C74.138 23.5459 74.128 23.5472 74.1176 23.5485C72.0776 23.7775 72.739 25.8946 72.739 25.8946C73.0766 26.6085 72.523 27.4071 72.523 27.4071C72.1141 28.7329 73.2436 28.7969 73.4523 28.8165C73.6605 28.8364 74.5846 28.9402 75.2519 29.0031C75.9189 29.0659 77.0508 29.6523 77.0508 29.6523C78.1699 30.1029 79.2189 29.8565 79.2189 29.8565C80.8081 29.1386 80.6293 27.7996 80.6293 27.7996Z",
    fill: "#BE7247"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4963 27.7257C80.5188 27.0815 79.8723 26.3695 79.1865 25.5574C78.5009 24.7452 78.0395 23.5572 78.0395 23.5572C77.6077 22.5946 77.0367 22.2954 76.643 22.2113C76.2269 22.0776 75.5729 22.2222 75.2061 22.6424C74.8106 23.0951 74.7105 23.1856 74.4053 23.4905C74.3083 23.5874 74.2358 23.6462 74.1815 23.6815C72.2383 23.9255 72.8634 25.9336 72.8634 25.9336C73.1871 26.6168 72.6476 27.3847 72.6476 27.3847C72.2457 28.658 73.3394 28.7143 73.5412 28.7324C73.7431 28.7504 74.6374 28.8458 75.2832 28.9033C75.9292 28.9604 77.0227 29.5177 77.0227 29.5177C78.1041 29.945 79.1213 29.704 79.1213 29.704C80.6634 29.0088 80.4963 27.7257 80.4963 27.7257Z",
    fill: "#F08128"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3585 27.6622C80.3779 27.0362 79.7523 26.342 79.0884 25.5502C78.4249 24.7588 77.9756 23.6026 77.9756 23.6026C77.378 22.2675 76.5124 22.24 76.2579 22.2635C76.1835 22.2681 76.1072 22.2787 76.0303 22.295C75.7191 22.3618 75.4042 22.5261 75.1859 22.7881C74.7825 23.2725 74.6712 23.3809 74.3714 23.6947C74.3431 23.6985 74.3143 23.7022 74.2851 23.7053C72.3813 23.9199 72.9975 25.8922 72.9975 25.8922C73.3118 26.5571 72.7948 27.3014 72.7948 27.3014C72.4123 28.5371 73.4663 28.5961 73.6607 28.6142C73.8554 28.6325 74.7176 28.7286 75.3402 28.7866C75.9626 28.8447 77.0182 29.3905 77.0182 29.3905C78.0621 29.8096 79.0411 29.5794 79.0411 29.5794C80.5243 28.9095 80.3585 27.6622 80.3585 27.6622Z",
    fill: "#FFD400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.3509 25.3364C78.3509 25.3364 77.3952 22.129 76.1727 22.8163C74.9503 23.5039 74.6297 24.0734 74.6297 24.0734C74.6297 24.0734 73.269 24.8533 75.8088 26.7106L78.3509 25.3364Z",
    fill: "url(#paint9_linear_8234_14407)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.9465 22.1727C89.9465 22.1727 91.4357 19.5296 88.3734 15.1883C88.3734 15.1883 87.5764 13.6782 88.4153 14.6849C88.4153 14.6849 92.1698 18.8166 90.9113 22.5711L89.9465 22.1727Z",
    fill: "url(#paint10_linear_8234_14407)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7694 22.0396C87.7694 22.0396 86.59 22.2084 86.4961 24.0649C86.4961 24.0649 86.4961 25.3965 86.1405 26.4467C85.7847 27.4973 85.429 28.4349 85.6911 29.0537C85.6911 29.0537 86.0095 30.3665 87.7506 30.4602C87.7506 30.4602 88.8179 30.3104 89.6978 29.485C89.6978 29.485 90.5405 28.5287 91.1396 28.2286C91.7388 27.9284 92.5625 27.4973 92.7498 27.4032C92.9368 27.3095 93.9667 26.8408 93.1052 25.7529C93.1052 25.7529 92.3003 25.2089 92.3565 24.4214C92.3565 24.4214 92.2068 22.2084 90.222 22.7334C88.2375 23.2585 87.7694 22.0396 87.7694 22.0396Z",
    fill: "#BE7247"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8043 22.2148C87.8043 22.2148 86.66 22.3765 86.5691 24.1536C86.5691 24.1536 86.5691 25.4282 86.224 26.4335C85.8789 27.4389 85.5337 28.3363 85.788 28.9288C85.788 28.9288 86.0968 30.1855 87.786 30.275C87.786 30.275 88.8214 30.1314 89.6752 29.3416C89.6752 29.3416 90.4926 28.4261 91.0738 28.1391C91.6549 27.8517 92.4544 27.439 92.6358 27.3491C92.8173 27.2593 93.8164 26.8107 92.981 25.7693C92.981 25.7693 92.1998 25.2486 92.2544 24.4948C92.2544 24.4948 92.109 22.3765 90.1837 22.8793C88.2583 23.3817 87.8043 22.2148 87.8043 22.2148Z",
    fill: "#F08128"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8326 22.2905C87.8326 22.2905 86.7317 22.4475 86.6443 24.177C86.6443 24.177 86.6443 25.4174 86.3124 26.3958C85.9803 27.3741 85.6484 28.2475 85.8931 28.8241C85.8931 28.8241 86.1901 30.0468 87.8151 30.1342C87.8151 30.1342 88.8114 29.9944 89.6325 29.2257C89.6325 29.2257 90.419 28.3349 90.9781 28.0555C91.5373 27.7757 92.3063 27.3742 92.481 27.2868C92.6555 27.1994 93.6169 26.7626 92.8129 25.7494C92.8129 25.7494 92.0615 25.243 92.114 24.509C92.114 24.509 91.9743 22.4476 90.122 22.9369C88.2696 23.4258 87.8326 22.2905 87.8326 22.2905Z",
    fill: "#FFD400"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.9236 25.9346C86.9236 25.9346 86.6531 22.5987 88.0416 22.7971C89.4299 22.9955 89.9348 23.41 89.9348 23.41C89.9348 23.41 91.4856 23.6444 89.7907 26.2951L86.9236 25.9346Z",
    fill: "url(#paint11_linear_8234_14407)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5959 22.0722C87.5959 22.0722 87.6815 20.8855 88.7829 21.1986C88.7829 21.1986 89.8842 21.455 90.4632 22.0722C90.4632 22.0722 90.9666 22.6607 90.2733 23.2019C90.2733 23.2019 89.827 23.5817 89.4757 23.7148C89.4757 23.7148 88.5263 24.1608 88.0232 23.5628C88.0232 23.5628 87.5864 23.0406 87.5959 22.0722Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8673 22.0681C87.8673 22.0681 87.9247 21.2694 88.666 21.4803C88.666 21.4803 89.407 21.653 89.7966 22.0681C89.7966 22.0681 90.1352 22.4643 89.669 22.8285C89.669 22.8285 89.3686 23.0838 89.1324 23.1734C89.1324 23.1734 88.4935 23.4738 88.1547 23.0711C88.1547 23.0711 87.861 22.7198 87.8673 22.0681Z",
    fill: "url(#paint12_linear_8234_14407)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4942 8.73503C46.1199 8.73503 46.6272 8.22793 46.6272 7.60238C46.6272 6.97683 46.1199 6.46973 45.4942 6.46973C44.8686 6.46973 44.3613 6.97683 44.3613 7.60238C44.3613 8.22793 44.8686 8.73503 45.4942 8.73503Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8234_14407",
    x1: 34.4375,
    y1: 23.73,
    x2: 73.8669,
    y2: 23.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0089,
    stopColor: "#FADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#F5B715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2988,
    stopColor: "#F09424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4433,
    stopColor: "#EC752A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5865,
    stopColor: "#E95B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#E8452B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    stopColor: "#E7382A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8234_14407",
    x1: 82.822,
    y1: 15.9757,
    x2: 82.3833,
    y2: 26.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8217,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8676,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9129,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8234_14407",
    x1: 83.8173,
    y1: 5.12853,
    x2: 83.875,
    y2: 21.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2381,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3692,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7553,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8801,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8234_14407",
    x1: 82.9432,
    y1: 12.0824,
    x2: 82.6212,
    y2: 16.8201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7701,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7951,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8248,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8849,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9145,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9437,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9724,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8234_14407",
    x1: 82.7976,
    y1: 4.63064,
    x2: 83.2805,
    y2: 10.9782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1239,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1971,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4145,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    stopColor: "#20201F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7277,
    stopColor: "#050505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8234_14407",
    x1: 80.8064,
    y1: 9.14907,
    x2: 81.0536,
    y2: 11.1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0427,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1123,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3373,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4175,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5942,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7074
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8234_14407",
    x1: 83.8479,
    y1: 8.70026,
    x2: 84.2046,
    y2: 11.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0427,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1123,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3373,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4175,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5942,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7074
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8234_14407",
    x1: 82.468,
    y1: 10.1426,
    x2: 82.231,
    y2: 13.9601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0954,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2091,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8234_14407",
    x1: 77.159,
    y1: 26.2119,
    x2: 77.3123,
    y2: 13.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1448,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2119,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2449,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2775,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3096,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3403,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5602,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8234_14407",
    x1: 79.5718,
    y1: 30.4707,
    x2: 73.2468,
    y2: 19.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#E1DA1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4832,
    stopColor: "#E4DE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5583,
    stopColor: "#EBE668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6343,
    stopColor: "#F1EE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#F6F4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7844,
    stopColor: "#FAF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#FDFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    stopColor: "#FEFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8234_14407",
    x1: 89.1377,
    y1: 13.7549,
    x2: 90.7936,
    y2: 27.0946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1257,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1699,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2995,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3403,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5602,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8234_14407",
    x1: 87.6439,
    y1: 31.1622,
    x2: 89.6729,
    y2: 18.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#E1DA1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4832,
    stopColor: "#E4DE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5583,
    stopColor: "#EBE668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6343,
    stopColor: "#F1EE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#F6F4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7844,
    stopColor: "#FAF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#FDFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    stopColor: "#FEFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8234_14407",
    x1: 88.1131,
    y1: 20.8283,
    x2: 89.1546,
    y2: 22.9406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#454544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0748,
    stopColor: "#6A6A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0928,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1108,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1287,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1637,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1803,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinuxBadge);
export default __webpack_public_path__ + "static/media/linux-badge.a1202529266ae54eb0fe268767f7cad1.svg";
export { ForwardRef as ReactComponent };